import type { Commodity, ProductDetail } from '@/types/product';
import type { CampaignBaseProps, cmdLabel, DiscIntro, fromPage, Label, ProductInfo, WithUrlKey } from './type';

/* eslint-disable @typescript-eslint/no-unused-vars */
const tradeUpProduct = [15, 13];
const profProd = [6];

/**
 * 非落地页活动相关：通用配置
 */
class CampaignBase {
  country: TBasicCountryInfo;
  CountryCode: TCountryCode;
  LANG: LANG;
  X_Language: X_Language;
  pageCommonConfig: object;
  insrc: string;
  enabled!: boolean;
  activityUrl!: string;

  constructor(props: CampaignBaseProps) {
    this.country = props.country;
    this.CountryCode = props.country.code;
    this.LANG = props.LANG;
    this.X_Language = props.country.X_Language;
    this.pageCommonConfig = props.pageCommonConfig;
    this.insrc = props.insrc?.toUpperCase() || '';
  }

  /**
   * 移动端浮窗相关配置
   */
  getHeaderEntry = (): object => {
    return {};
  };

  /**
   * tradeup相关配置
   */
  getTradeUp = (product: WithUrlKey): object => {
    return {};
  };

  /**
   * 是否启用活动
   */
  enableProductPage = (pInfo: ProductInfo, from: fromPage): boolean => {
    const { pid } = pInfo;
    switch (from) {
      case 'countdown':
      case 'tag':
      case 'discountIntro':
      case 'intro':
        return this.enabled;
      // 以旧换新暂时下线
      // case 'tradeup':
      //   return this.enabled && tradeUpProduct.includes(pid);
      case 'professional_discount':
        return this.enabled && profProd.includes(pid);
      default:
        return false;
    }
  };

  /**
   * 是否启用移动端浮窗
   */
  enableHeaderEntry = (product: ProductDetail): boolean => {
    return (
      this.enabled &&
      ![
        '/water-sports',
        '/water-sports/',
        '/wintersports',
        '/wintersports/',
        '/biking',
        '/biking/',
        '/motorcycling',
        '/motorcycling/',
        this.activityUrl,
        `${this.activityUrl}/`,
      ].includes(window.location.pathname)
    );
  };

  /**
   * 获取套餐减价折扣文案描述
   */
  getProductIntro = (pInfo: ProductInfo): string | null => {
    return null;
  };

  /**
   * 配置产品页折扣/营销文案
   * 大促上线时，需要注意产品页常驻活动的营销文案，有可能大促上线期间常驻营销文案需要隐藏！！！
   * new: 记得带上isLastWeek字段
   */
  getProductDiscountIntro = (pInfo: ProductInfo): DiscIntro => {
    return '';
  };

  /**
   * 获取倒计时参数
   */
  getCountDownProps = (pInfo: ProductInfo): object => {
    return {};
  };

  /**
   * 获取套餐标签，删掉limitOffer
   */
  getCommodityLabel = (commodity: Commodity, currentLabels: Label[], LANG: LANG): cmdLabel => {
    return {
      replaceLabels: currentLabels.filter((d: object) => 'tagName' in d && d.tagName !== 'savePrice'),
    };
  };

  /**
   * 获取虚拟服务配置的对应文案
   */
  getCartServiceText = (serviceId: number, from?: string): string | null => {
    return null;
  };

  getDiscountInfoAfterActivity = (pInfo: ProductInfo): { text: string; locale: string } => {
    return { text: '', locale: '' };
  };

  /**
   * 获取导航购物车浮窗内展示文字
   */
  getCartCardText = (selectCartItems: Array<unknown>, cartItems: Array<unknown>): JSX.Element | null => {
    return null;
  };

  /**
   * 购物车页面促销文案
   */
  getCartPageText = (itemList: Array<unknown>, cartItems?: Array<unknown>): JSX.Element | null => {
    return null;
  };

  /**
   * 支付方式右上角的红色标
   */
  getPaymentItemTag = (type: string, itemList: Array<unknown>, orderGifts: Array<unknown>, area: string): string => {
    return '';
  };

  /**
   * 排列支付方式
   */
  sortPaymentMethods = (
    Methods: Array<unknown>,
    itemList: Array<unknown>,
    orderConfirmGifts: Array<unknown>,
    area: string
  ): Array<unknown> => {
    return [];
  };

  /**
   * 购物车与产品页care/flexicare是否在活动期间展示折扣tag
   */
  showCampaignServiceLabel = (cmd: Commodity, pid: number): boolean => {
    return false;
  };

  /**
   * 产品页赠品文案隐藏特定赠品
   */
  hideGiftIntro = (pid: number): { giftCids: number | number[] } | boolean => {
    return false;
  };
}

export default CampaignBase;
